import React, { useState } from 'react';
import '../App.css';
import {PriceChange, Business, ManageAccounts, CalendarMonth, Addchart, Houseboat, PriceCheck, RequestQuote, Badge, Dashboard, PostAdd, History, Assignment, TrackChanges, AccountCircle, VpnKey} from '@mui/icons-material';
import {SocialDistance, Summarize, MoneyOff, CurrencyRuble,ArrowBackIos, PowerSettingsNew, Receipt, AccountBalance, Assessment, Factory, HealthAndSafety, CurrencyRupee, Savings, Security, TrendingUp, Work, People, Water, CleanHands, VolunteerActivism, PeopleAlt} from '@mui/icons-material';
import {PermDataSetting, SettingsApplications, CropRotate, RoomPreferences, ExpandMore, ExpandLess} from '@mui/icons-material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { AiOutlineTransaction } from "react-icons/ai";
import { GiTakeMyMoney, GiMoneyStack, GiHealthIncrease, GiFamilyHouse, GiPiggyBank, GiStairsGoal, GiWaterDrop, GiRupee } from "react-icons/gi";
import { FaRupeeSign, FaUserTie, FaChartLine, FaShieldAlt, FaWallet, FaHandHolding } from "react-icons/fa";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import {Menu as MenuIcon} from '@mui/icons-material';
import {IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Divider, Avatar} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../store/auth-slice';
import { getStoredCompanyDetails, getCompanyDisplayFromDetails } from '../services/companyService';
import Notification from './Notification';

// Import DrawerListItem
import DrawerListItem from './DrawerListItem';

const subMenus = [
  [["Dashboard", 'dashboard', <Dashboard/>]],
  [
   ["Company Details", 'company-master/view-companies', <Business/>], 
   ["Employee Roles", 'company-master/employee-roles', <FaUserTie size={20}/>],
   ["Auto Earning/Deduction", 'company-master/earning-deduction', <FaRupeeSign size={20}/>],
   ["Insert Company Logo", 'company-master/insert-header',<Addchart/>], 
   ["User Management", 'company-master/user-management',<ManageAccounts/>, { adminOnly: true }], 
   ["API Keys", 'company-master/api-keys', <VpnKey/>],
   ["Leave Master", 'company-master/leave-master-form',<CalendarMonth/>], 
   ["Holiday Master",'company-master/holiday-master',<Houseboat/>], 
   ["Import from EXCEL",'company-master/data-manager',<Houseboat/>]
  ],
  [["Employee Master", 'employee-master/view-employees', <Badge/>], 
   ["Earning & Deduction Master", 'employee-master/earning-and-deduction-master', <FaRupeeSign size={20}/>]],
  [
   ["Intern/Apprentice Master", 'intern-apprentice-master', <Badge/>]
  ],
  [
   ["Create Payroll", 'create-payroll', <PostAdd sx={{ fontSize: 28 }}/>],
   ["Process Stipend", 'stipend-payroll', <Work sx={{ fontSize: 26 }}/>]
  ],
  [], // Income Tax - No submenu, direct navigation
  [
    ["Salary ", 'reports/salary-report', <FaRupeeSign size={20}/>],
    ["Income Tax ", 'reports/income-tax-report', <Receipt sx={{ fontSize: 22 }}/>],
    ["Provident Fund ", 'reports/provident-fund-report', <GiPiggyBank size={22}/>],
    ["ESI Statement ", 'reports/esi-statement-report', <HealthAndSafety sx={{ fontSize: 22 }}/>],
    ["Profession Tax ", 'reports/professional-tax-report', <FaRupeeSign size={20}/>],
    ["Welfare Fund ", 'reports/welfare-fund-report', <VolunteerActivism sx={{ fontSize: 22 }}/>],
    ["Stipend ", 'reports/stipend-report', <Work sx={{ fontSize: 22 }}/>],
    ["Seperation Rate ", 'reports/separation-rate-report', <TrendingUp sx={{ fontSize: 22 }}/>],
    ["Gratuity ", 'reports/gratuity-report', <Box sx={{ position: 'relative', width: 22, height: 22, display: 'inline-flex' }}>
      <FaHandHolding size={18} style={{ position: 'absolute', left: 0, bottom: 0 }} />
      <CurrencyRupee sx={{ fontSize: 12, position: 'absolute', right: 0, top: 0 }} />
    </Box>],
    ["Top Employees ", 'reports/top-employees-report', <PeopleAlt sx={{ fontSize: 22 }}/>]
  ],
  // Configure menu - index 6 with Indian standard icons
  [["PT Slabs ",'configure/pt-slabs-configure', <FaRupeeSign size={20}/>],
   ["PF Rules ",'configure/pf-rules-configure', <GiPiggyBank size={22}/>],
   ["CTC Structure", 'configure/ctc-configure', <Assessment sx={{ fontSize: 22 }}/>],
   ["ESIC Slabs", 'configure/esic-configure', <HealthAndSafety sx={{ fontSize: 22 }}/>],
   ["W.F. Slabs", 'configure/wf-configure', <VolunteerActivism sx={{ fontSize: 22 }}/>],
   ["TDS Rules", 'configure/tds-configure', <FaRupeeSign size={20}/>],
   ["Gratuity Eligibility", 'configure/gratuity-configure', (
    <Box sx={{ position: 'relative', width: 22, height: 22, display: 'inline-flex' }}>
      <FaHandHolding size={18} style={{ position: 'absolute', left: 0, bottom: 0 }} />
      <CurrencyRupee sx={{ fontSize: 12, position: 'absolute', right: 0, top: 0 }} />
    </Box>
   )]],
  [""], // Audit Logs - index 7
  [""], // ChangeCompany - index 8
  [""], // Help - index 9
]

const menuItems = [
  { text: 'Dashboard', hasSubmenu: false, path: '/dashboard' },
  { text: 'Company Master', hasSubmenu: true, path: '' },
  { text: 'Employee Master', hasSubmenu: true, path: '' },
  { text: 'Intern/Apprentice Master', hasSubmenu: true, path: '' },
  { text: 'Payroll', hasSubmenu: true, path: '' },
  { text: 'Income Tax', hasSubmenu: false, path: '/income-tax' },
  { text: 'Reports', hasSubmenu: true, path: '' },
  { text: 'Configure', hasSubmenu: true, path: '' },
  { text: 'Audit Logs', hasSubmenu: false, path: '/audit-logs' },
  { text: 'Change Company', hasSubmenu: false, path: '/switch-company' },
  { text: 'Help', hasSubmenu: false, path: '/help' },
];

// Define the custom color
const customBlue = '#0b418e';

export default function TemporaryDrawer() {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [openMenus, setOpenMenus] = React.useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [selectedPath, setSelectedPath] = React.useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Get user and company info from Redux or localStorage (company details table)
  const userName = localStorage.getItem('activeUserName') || 'John Doe';
  const isAdmin = useSelector((state) => state.auth.activeUserRole) === 'ADMIN';
  const isSubItemVisible = (subItem) => !(subItem[3] && subItem[3].adminOnly) || isAdmin;
  const companyDetails = useSelector((state) => state.auth.activeCompanyDetails) || getStoredCompanyDetails();
  const { companyName: displayCompanyName } = getCompanyDisplayFromDetails(companyDetails || {});

  // Set selected path based on current location
  React.useEffect(() => {
    setSelectedPath(location.pathname);
    
    // Auto-expand parent menu if a submenu item is selected
    menuItems.forEach((item, index) => {
      if (item.hasSubmenu && subMenus[index] && subMenus[index][0] !== "") {
        const hasActiveSubItem = subMenus[index].some(
          subItem => subItem[1] && location.pathname.includes(subItem[1])
        );
        if (hasActiveSubItem) {
          setOpenMenus(prev => ({ ...prev, [index]: true }));
        }
      }
    });
  }, [location.pathname]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
    // Reset all open menus when drawer closes
    if (!open) {
      setOpenMenus({});
    }
  };

  const handleMenuClick = (index) => {
    setOpenMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleLogoutClick = () => {
    setState({ ...state, left: false });
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmLogout = async () => {
    handleCloseConfirmDialog();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/company-master/logout`, {
        credentials: 'include',
      });
      if (response.status === 200) {
        dispatch(authActions.setLogout());
        dispatch(authActions.clearCompanyLogo());
        localStorage.removeItem('activeUserName');
        localStorage.removeItem('companyLogoURL');
        localStorage.removeItem('companyLogoBase64');
        localStorage.removeItem('activeCompanyDetails');
        setNotify({ isOpen: true, message: 'Successfully Logged Out!', type: 'success' });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        setNotify({ isOpen: true, message: 'Failed to logout. Please try again.', type: 'error' });
      }
    } catch (err) {
      setNotify({ isOpen: true, message: 'Logout error. Please try again.', type: 'error' });
    }
  };

  const handleMenuItemClick = (item, index) => {
    if (item.hasSubmenu) {
      handleMenuClick(index);
    } else {
      // Handle non-submenu items - direct navigation
      setState({ ...state, left: false });
      if (item.path) {
        setSelectedPath(item.path);
        navigate(item.path);
      }
    }
  };

  const handleSubMenuItemClick = (path) => {
    setState({ ...state, left: false });
    setOpenMenus({});
    setSelectedPath(path);
    navigate(path);
  };

  const getMenuIcon = (menuText) => {
    switch(menuText) {
      case 'Dashboard': return <Dashboard sx={{ color: customBlue }} />;
      case 'Company Master': return <Business sx={{ color: customBlue }} />;
      case 'Employee Master': return <Badge sx={{ color: customBlue }} />;
      case 'Intern/Apprentice Master': return <Badge sx={{ color: customBlue }} />;
      case 'Payroll': return <PostAdd sx={{ color: customBlue }} />;
      case 'Income Tax': return <Receipt sx={{ color: customBlue }} />;
      case 'Reports': return <Summarize sx={{ color: customBlue }} />;
      case 'Configure': return <SettingsApplications sx={{ color: customBlue }} />;
      case 'Audit Logs': return <History sx={{ color: customBlue }} />;
      case 'Change Company': return <Houseboat sx={{ color: customBlue }} />;
      case 'Help': return <SocialDistance sx={{ color: customBlue }} />;
      default: return <Dashboard sx={{ color: customBlue }} />;
    }
  };

  const isMenuItemSelected = (item, index) => {
    if (!item.hasSubmenu) {
      return selectedPath === item.path || selectedPath.includes(item.path);
    }
    // Check if any submenu item is selected - this highlights the parent menu
    return subMenus[index]?.some(subItem => 
      subItem[1] && selectedPath.includes(subItem[1])
    );
  };

  const list = (anchor) => (
    <Box
      sx={{ 
        width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 320,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'background.paper',
      }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {/* Drawer Header - Updated with center-aligned company name and better spacing */}
      <Box sx={{ 
        p: 2.5, 
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        bgcolor: customBlue,
        color: 'white'
      }}>
        {/* User Icon and Company Name - Centered */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 1.5,
          mb: 2 // Margin bottom for spacing between company name and IDs
        }}>
          <Avatar sx={{ bgcolor: 'white', color: customBlue, width: 48, height: 48 }}>
            <AccountCircle sx={{ fontSize: 32 }} />
          </Avatar>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontWeight: 600, 
              textAlign: 'center',
              lineHeight: 1.3,
              px: 1,
              whiteSpace: 'nowrap',
              display: 'block',
              width: '100%',
              overflow: 'visible',
              textOverflow: 'clip',
              maxWidth: '100%'
            }}
          >
            {displayCompanyName || 'Company'}
          </Typography>
        </Box>
        
        {/* User and Company name from company details table */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 1,
          pt: 1,
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          fontSize: '0.8rem',
          opacity: 0.9
        }}>
          <Typography variant="caption" style={{marginLeft: '46px'}} sx={{ color: 'white', fontWeight: 500 }}>
            User: {userName}{isAdmin ? ' (Admin)' : ''}
          </Typography>
          
        </Box>
      </Box>

      {/* Menu Items - No dividers, continuous list */}
      <List sx={{ flexGrow: 1, overflow: 'auto', py: 1 }}>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.text}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleMenuItemClick(item, index)}
                selected={isMenuItemSelected(item, index)}
                sx={{
                  py: 1.2,
                  px: 2,
                  '&:hover': {
                    bgcolor: 'rgba(11, 65, 142, 0.08)',
                  },
                  '&.Mui-selected': {
                    bgcolor: 'rgba(11, 65, 142, 0.12)',
                    borderLeft: '4px solid',
                    borderLeftColor: customBlue,
                    '& .MuiListItemIcon-root': {
                      color: customBlue,
                    },
                    '& .MuiListItemText-primary': {
                      color: customBlue,
                      fontWeight: 600,
                    }
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  {getMenuIcon(item.text)}
                </ListItemIcon>
                <ListItemText 
                  primary={item.text}
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: isMenuItemSelected(item, index) ? 600 : 500,
                      fontSize: '15px',
                    }
                  }}
                />
                {/* Only show dropdown arrow for menus that actually have submenus and are not empty */}
                {item.hasSubmenu && subMenus[index] && subMenus[index][0] !== "" && (
                  <Box sx={{ ml: 'auto' }}>
                    {openMenus[index] ? (
                      <ExpandLess sx={{ color: customBlue }} />
                    ) : (
                      <ExpandMore sx={{ color: 'action.active' }} />
                    )}
                  </Box>
                )}
              </ListItemButton>
            </ListItem>
            
            {/* Submenu - only render for menus with actual submenu items */}
            {item.hasSubmenu && subMenus[index] && subMenus[index][0] !== "" && (
              <Collapse in={openMenus[index]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {subMenus[index].map((subItem, subIndex) => isSubItemVisible(subItem) && (
                    <ListItemButton
                      key={`${index}-${subIndex}`}
                      onClick={() => handleSubMenuItemClick(subItem[1])}
                      sx={{
                        pl: 4,
                        py: 0.8,
                        '&:hover': {
                          bgcolor: 'rgba(11, 65, 142, 0.04)',
                        }
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <Box sx={{ 
                          color: 'text.secondary',
                          fontSize: '20px',
                          opacity: 0.85,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {subItem[2]}
                        </Box>
                      </ListItemIcon>
                      <ListItemText 
                        primary={subItem[0]}
                        primaryTypographyProps={{
                          sx: {
                            fontSize: '14px',
                            color: 'text.secondary',
                            opacity: 0.85,
                          }
                        }}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
            
            {/* No dividers - removed completely */}
          </React.Fragment>
        ))}
      </List>

      {/* Logout Section */}
      <Box sx={{ 
        flexShrink: 0, 
        bgcolor: '#f5f5f5',
        borderTop: '2px solid rgba(0, 0, 0, 0.08)',
        p: 1.5
      }}>
        <ListItemButton 
          onClick={handleLogoutClick}
          sx={{
            borderRadius: '12px',
            py: 1.5,
            px: 2,
            transition: 'all 0.2s',
            '&:hover': {
              bgcolor: '#ffebee',
              transform: 'translateX(4px)',
              '& .logout-icon': {
                color: '#d32f2f',
              }
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 36,
                height: 36,
                borderRadius: '10px',
                bgcolor: 'rgba(244, 67, 54, 0.1)',
              }}
            >
              <PowerSettingsNew 
                className="logout-icon"
                sx={{ 
                  color: '#f44336',
                  fontSize: '22px',
                }} 
              />
            </Box>
          </ListItemIcon>
          <ListItemText 
            primary="Logout"
            primaryTypographyProps={{
              sx: {
                fontSize: '15px',
                fontWeight: 600,
                color: '#d32f2f',
              }
            }}
          />
        </ListItemButton>
      </Box>
    </Box>
  );

  return (
    <div>
      <React.Fragment key='left'>
        <IconButton
          onClick={toggleDrawer('left', true)}
          size="large"
          edge="start"
          aria-label="menu"
          sx={{ 
            mr: 2,
            '&:hover': {
              bgcolor: 'rgba(11, 65, 142, 0.04)',
            }
          }}
        >
          <MenuIcon/>
        </IconButton>
        <Drawer
          anchor='left'
          open={state['left']}
          onClose={toggleDrawer('left', false)}
          PaperProps={{
            sx: {
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            }
          }}
        >
          {list('left')}
        </Drawer>
      </React.Fragment>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            minWidth: 400,
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600 }}>
          {'Confirm Logout'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button 
            onClick={handleCloseConfirmDialog}
            variant="outlined"
            sx={{ borderRadius: '8px' }}
          >
            No
          </Button>
          <Button 
            onClick={handleConfirmLogout} 
            variant="contained" 
            color="error"
            sx={{ borderRadius: '8px' }}
            autoFocus
          >
            Yes, Logout
          </Button>
        </DialogActions>
      </Dialog>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
}